/** Shared input validation. One email check for every form — previously four
 *  per-file EMAIL_RE constants existed on mobile with two different strictness
 *  levels (the loose `/.+@.+\..+/` accepted internal whitespace). */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

/** The shape of an id carried in a link (`?category_id=`): 36 hex/dash chars, not a strict UUID. */
export const UUID_SHAPE_RE = /^[0-9a-f-]{36}$/i;
